<template>
  <div class="not-found-page" :class="$darkMode.get() ? 'bg-dark-svg' : 'bg-light-svg'">
    <div class="centered">
      <template v-if="error.statusCode === 404">
        <h1><i class="not-found-icon nc-icon nc-puzzle-10"></i>404</h1>
        <p>La página que buscas no se encuentra.</p>
      </template>

      <template v-else>
        <h1><i class="not-found-icon nc-icon nc-puzzle-10"></i>ERROR</h1>
        <p>Ha ocurrido un error, recarga la página para continuar.</p>
      </template>

      <base-button native-type="submit" type="primary" class="mt-4 mb-1" size="md" block @click="goback">{{
        error.statusCode === 404 ? 'INICIO' : 'RECARGAR'
      }}</base-button>

      <!-- TODO: notificar errores -->
      <!-- <p>Notificar del error.</p> -->

      <card v-if="error.statusCode !== 404">
        <collapse>
          <collapse-item style="padding: 10px 0px" title="Detalle del error">
            {{ error }}
          </collapse-item>
        </collapse>
      </card>
    </div>
  </div>
</template>

<script>
import { Collapse, CollapseItem } from '@/components'

export default {
  layout: 'blank',
  components: {
    Collapse,
    CollapseItem
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['error'],

  methods: {
    goback() {
      if (!this.error || this.error.statusCode !== 404) this.$router.go()
      else this.$router.push('/')
    }
  }
}
</script>
<style lang="scss">
.not-found-page {
  .full-page > .content,
  .centered {
    min-height: calc(100vh - 160px);
  }
  .not-found-icon {
    margin-right: 10px;
  }
  .centered {
    h1,
    i {
      font-size: 50px;
    }
    p {
      font-size: 20px;
    }
    display: flex;
    padding-bottom: 150px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
  }
}
</style>

